import { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

const COLORS = ["#10B981", "#042F1E", "#F59E0B", "#B4884E", "#94A3B8"];
const TICK_STYLE = { fontSize: 11, fill: "#042F1E99" };
const CURSOR_STYLE = { fill: "rgba(16,185,129,0.06)" };
const TOOLTIP_STYLE = { borderRadius: 12, border: "1px solid rgba(4,47,30,0.1)", fontSize: 12 };
const LEGEND_STYLE = { fontSize: 12 };
const TOP_BAR_RADIUS = [3, 3, 0, 0];

const buildData = (leads) => {
  const days = [];
  for (let i = 13; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    days.push(d.toISOString().slice(0, 10));
  }
  const counts = {};
  const sourceTotals = {};
  leads.forEach((l) => {
    const day = (l.created_at || "").slice(0, 10);
    if (!days.includes(day)) return;
    const src = l.utm_source || "direct";
    counts[day] = counts[day] || {};
    counts[day][src] = (counts[day][src] || 0) + 1;
    sourceTotals[src] = (sourceTotals[src] || 0) + 1;
  });
  const sources = Object.keys(sourceTotals).sort((a, b) => sourceTotals[b] - sourceTotals[a]).slice(0, 5);
  const data = days.map((day) => {
    const row = { day: new Date(`${day}T12:00:00`).toLocaleDateString("en-CA", { month: "short", day: "numeric" }) };
    sources.forEach((s) => {
      row[s] = counts[day]?.[s] || 0;
    });
    return row;
  });
  return { data, sources };
};

export const SourceChart = ({ leads }) => {
  const { data, sources } = useMemo(() => buildData(leads), [leads]);

  if (!sources.length) return null;

  return (
    <div data-testid="source-chart" className="mt-6 rounded-3xl border border-forest/10 bg-white p-6">
      <p className="font-syne text-sm font-extrabold text-forest">Signups by source — last 14 days</p>
      <div className="mt-4 h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barCategoryGap="30%">
            <XAxis dataKey="day" tick={TICK_STYLE} tickLine={false} axisLine={false} />
            <YAxis allowDecimals={false} width={28} tick={TICK_STYLE} tickLine={false} axisLine={false} />
            <Tooltip cursor={CURSOR_STYLE} contentStyle={TOOLTIP_STYLE} />
            <Legend wrapperStyle={LEGEND_STYLE} />
            {sources.map((s, i) => (
              <Bar key={s} dataKey={s} stackId="a" fill={COLORS[i % COLORS.length]} radius={i === 0 ? TOP_BAR_RADIUS : 0} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
